import { type FC } from "react";

import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { getGeneTypeDisplayValue } from "./GeneTypeCell.js";
import ListCellContent, { type ListCellItem } from "./core/ListCellContent.js";
import { TableCell } from "./core/TableCell.js";

const GeneTypesListCell: FC<IAgGridCellProps> = (props) => {
  if (!props.value) {
    return null;
  }

  const types: string[] = props.value;

  const items: ListCellItem[] = types.map((type: string) => ({
    value: getGeneTypeDisplayValue(type),
    tooltip: type,
  }));

  return (
    <TableCell>
      <ListCellContent items={items} colDef={props.colDef} context={props.context} />
    </TableCell>
  );
};

export { GeneTypesListCell };
export default GeneTypesListCell;
